<div class="flex flex-row flex-wrap items-center justify-items-start gap-1">
  @for (element of elements$ | async; track element.display.metadataKey) {
    <pr-patient-metadata-display
      [value]="element.value"
      [display]="element.display"
    />
  }
</div>
